<template>
  <div>
    <div @click="openModal()" class="singup-button" style="min-width: 91px; padding: 14px">
      Sign Up
    </div>

    <div class="modal fade" id="newsletterModal" tabindex="-1" role="dialog" aria-labelledby="languageMenuLabel" aria-hidden="true">
      <div class="container">
        <div class="modal-dialog" role="document">
          <div class="modal-content" style="background-color: transparent !important; border: none !important;">
            <div class="modal-wrapper" style="background: white;padding: 30px;border-radius: 10px; position: relative;">
              <div class="modal-overlay d-none"></div>
              <button type="button" data-dismiss="modal" aria-label="Close" style="text-align: right; position:absolute; right: 20px; background: none; border: none;">
                <img class="close-button ls-is-cached lazyloaded" data-dismiss="modal" data-src="https://objects.kaxmedia.com/auto/o/139743/184652870c.svg" src="https://objects.kaxmedia.com/auto/o/139743/184652870c.svg" style="right: 15px;z-index:9999999">
              </button>
              <div class="modal-body">
                <div class="subscription-container">
                  <div class="hero-image">
                    <img class="m-auto" src="https://objects.kaxmedia.com/auto/o/167084/1317a44096.svg" alt="">
                  </div>
                  <div class="hero-title w-100" v-html="translations.subscription_modal_title">
                  </div>
                  <div class="hero-text w-100">
                    {{ translations.subscription_modal_text }}
                  </div>
                </div>

                <div id="subscription-form-subscribe" class="subscription-container">
                  <subscription-form></subscription-form>
                </div>
                <div class="newsletter-subscription-response hidden">
                  <div class="hero-image">
                    <img class="m-auto" src="https://objects.kaxmedia.com/auto/o/167084/1317a44096.svg" alt="">
                  </div>
                  <div class="hero-title w-100" v-html="translations.subscribed_title">
                  </div>
                  <div class="hero-text w-100">
                    {{ translations.subscribed_text }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      id: null,
      translations: {
        email_enter_email: null,
        subscribed_title: null,
        subscribed_text: null,
        subscription_modal_title: null,
        subscription_modal_text: null,
        subscribe_button_text: null,
        agree_message: null,
        input_validation_error: null,
        checkbox_validation_error: null,
        email_validation_error: null,
      },
    };
  },
  mounted() {
    this.translations = this.$root.translations;
  },
  methods: {
    openModal: function () {
      $('#newsletterModal').appendTo("body").modal('show');
    },
  },
};
</script>


